import React, { useState, useEffect } from 'react';

const TestTimer = ({ suggestedTimeInMinutes }) => {
  const [startTime] = useState(() => {
    // Try to get stored start time, or create new one
    const stored = sessionStorage.getItem('testStartTime');
    return stored || Date.now().toString();
  });
  const [currentTime, setCurrentTime] = useState(Date.now());
  const [timerColor, setTimerColor] = useState('var(--success)');

  // Store start time in session storage when test begins
  useEffect(() => {
    if (!sessionStorage.getItem('testStartTime')) {
      sessionStorage.setItem('testStartTime', startTime);
    }
  }, [startTime]);

  useEffect(() => {
    const timer = setInterval(() => {
      const now = Date.now();
      setCurrentTime(now);
      
      // Calculate remaining time
      const elapsedSeconds = Math.floor((now - parseInt(startTime)) / 1000);
      const totalSeconds = suggestedTimeInMinutes * 60;
      const remainingSeconds = totalSeconds - elapsedSeconds;
      const percentageLeft = (remainingSeconds / totalSeconds) * 100;
      
      // Update colors based on remaining time
      if (percentageLeft <= 10) {
        setTimerColor('var(--error)');
      } else if (percentageLeft <= 25) {
        setTimerColor('var(--warning)');
      } else {
        setTimerColor('var(--success)');
      }
    }, 1000);

    return () => clearInterval(timer);
  }, [startTime, suggestedTimeInMinutes]);

  const formatTime = () => {
    const elapsedSeconds = Math.floor((currentTime - parseInt(startTime)) / 1000);
    const totalSeconds = suggestedTimeInMinutes * 60;
    const remainingSeconds = Math.max(0, totalSeconds - elapsedSeconds);
    
    const mins = Math.floor(remainingSeconds / 60);
    const secs = remainingSeconds % 60;
    return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
  };

  return (
    <div style={{ 
      display: 'flex',
      alignItems: 'center',
      gap: 'var(--spacing-xs)',
      color: timerColor,
      transition: 'color 0.3s ease',
      fontWeight: 'bold',
      fontSize: 'var(--font-size-lg)'
    }}>
      <span>⏱️</span>
      {formatTime()}
    </div>
  );
};

export default TestTimer; 